import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35cbdba9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = { class: "labels" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Name")
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "used" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Used")
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "rating" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Rating")
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "ctr" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("CTR")
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "cpc" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("CPC")
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "cpm" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("CPM")
const _hoisted_20 = ["src"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "used" }
const _hoisted_23 = { class: "rating" }
const _hoisted_24 = { class: "ctr" }
const _hoisted_25 = { class: "cpc" }
const _hoisted_26 = { class: "cpm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_function_group_selector = _resolveComponent("function-group-selector")!
  const _component_search = _resolveComponent("search")!
  const _component_profile_drop_down = _resolveComponent("profile-drop-down")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_function_group_selector),
      _createVNode(_component_search)
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("img", {
            src: _ctx.sortIcon,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sort("name")))
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("span", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("img", {
            src: _ctx.sortIcon,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort("used")))
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("span", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("img", {
            src: _ctx.sortIcon,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort("rating")))
          }, null, 8, _hoisted_11)
        ]),
        _createElementVNode("span", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("img", {
            src: _ctx.sortIcon,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort("ctr")))
          }, null, 8, _hoisted_14)
        ]),
        _createElementVNode("span", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("img", {
            src: _ctx.sortIcon,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort("cpc")))
          }, null, 8, _hoisted_17)
        ]),
        _createElementVNode("span", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("img", {
            src: _ctx.sortIcon,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sort("cpm")))
          }, null, 8, _hoisted_20)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profiles, (profile) => {
        return (_openBlock(), _createElementBlock("div", {
          key: profile.name,
          class: "profile"
        }, [
          _createElementVNode("span", {
            class: "name",
            onClick: ($event: any) => (_ctx.editProfileChannels(profile.id))
          }, _toDisplayString(profile.name), 9, _hoisted_21),
          _createElementVNode("span", _hoisted_22, _toDisplayString(profile.used), 1),
          _createElementVNode("span", _hoisted_23, _toDisplayString(profile.rating), 1),
          _createElementVNode("span", _hoisted_24, _toDisplayString(profile.ctr) + "%", 1),
          _createElementVNode("span", _hoisted_25, "€" + _toDisplayString(profile.cpc), 1),
          _createElementVNode("span", _hoisted_26, "€" + _toDisplayString(profile.cpm), 1),
          _createVNode(_component_profile_drop_down, {
            class: "drop-down",
            profile: profile
          }, null, 8, ["profile"])
        ]))
      }), 128))
    ])
  ]))
}